import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import ModalButtons from '../../components/Modal/ModalButtons';
import DeleteModalSkeleton from '../../components/Skeletons/DeleteModalSkeleton';
import { getFormTitle } from '.';

const DeleteFormModal = ({ selectedFormDelete, loading, handleDeleteModalClose, handleDelete }) => {
  const { t } = useTranslation();
  return (
    <Modal show={selectedFormDelete._id}>
      <ModalHeading heading={t('screens.websiteForms.deleteTitle')} />
      {loading ? (
        <DeleteModalSkeleton />
      ) : (
        <ModalForm style={{ marginBottom: '2.5rem' }}>
          <InputsSection style={{ width: '34rem' }}>
            <p className='dangerText'>{t('screens.websiteForms.deleteConfirm')}</p>
            <div>
              <p className='primaryText'>{t('screens.websiteForms.formType', { type: getFormTitle(selectedFormDelete.type, selectedFormDelete.agent, t) })}</p>
              <p className='primaryText'>{t('screens.websiteForms.sentBy', { from: selectedFormDelete.from })}</p>
            </div>
          </InputsSection>

          <ModalButtons submitButtonLabel={t('screens.websiteForms.deleteBtn')} onSubmit={handleDelete} cancelButtonLabel={t('screens.websiteForms.cancel')} onCancel={handleDeleteModalClose} />
        </ModalForm>
      )}
    </Modal>
  );
};

export default DeleteFormModal;
